import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Button } from 'seagull';
import { Intent } from '~/infra/access-control';
import styles from './BottomArea.module.scss';
export default function BottomArea(param) {
    let { selected, onClick, testId } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.bottomArea,
        children: selected ? /*#__PURE__*/ _jsx(Typography, {
            className: styles.selectedIndicator,
            testId: "".concat(testId, "-selected"),
            children: "Selected"
        }) : /*#__PURE__*/ _jsx(Button, {
            intent: Intent.SelectPackage,
            testId: "".concat(testId, "-select-btn"),
            skin: "primaryOutlineOpaque",
            onClick: onClick,
            children: "Select"
        })
    });
}
